import type { DefaultOptionType } from "antd/es/select"

export const OTHER_TOP_LEVEL_CATEGORY = "Other"

/**
 * #1346 / #1371. Like `Other`, a SYNTHETIC top-level category: it names an object type rather than a
 * node of `GET /categories/`, which is why it has to be added to the dropdown by hand. Converting an
 * existing object to it sends the literal string `"custom"` as `related_category_id`.
 */
export const CUSTOM_TOP_LEVEL_CATEGORY = "Custom"

/**
 * The two synthetic top levels an EXISTING object can be converted to, in the order the design
 * lists them under the real categories.
 *
 * The create-object panels deliberately do not use this: each object type has its own + Add entry
 * (`Other` → REQ-299, `Custom` → #1371), so their dropdowns exclude both.
 */
export const SYNTHETIC_TOP_LEVEL_OPTIONS: DefaultOptionType[] = [
	{ label: OTHER_TOP_LEVEL_CATEGORY, value: OTHER_TOP_LEVEL_CATEGORY },
	{ label: CUSTOM_TOP_LEVEL_CATEGORY, value: CUSTOM_TOP_LEVEL_CATEGORY },
]

/**
 * The synthetic top levels that carry NO super category and no object category, so the two lower
 * selects are hidden while one of them is chosen. Both do today; the set exists so the rule is
 * stated once rather than re-derived at each render site.
 */
export const CATEGORYLESS_TOP_LEVEL_CATEGORIES: readonly string[] = [
	OTHER_TOP_LEVEL_CATEGORY,
	CUSTOM_TOP_LEVEL_CATEGORY,
]

export const isCategorylessTopLevel = (value: string | number | null | undefined): boolean =>
	typeof value === "string" && CATEGORYLESS_TOP_LEVEL_CATEGORIES.includes(value)

export const OTHER_TOP_LEVEL_OPTIONS: DefaultOptionType[] = [
	{ label: OTHER_TOP_LEVEL_CATEGORY, value: OTHER_TOP_LEVEL_CATEGORY },
]

/** The lone "Custom" option, for the #1371 create panel, whose dropdown is locked to it. */
export const CUSTOM_TOP_LEVEL_OPTIONS: DefaultOptionType[] = [
	{ label: CUSTOM_TOP_LEVEL_CATEGORY, value: CUSTOM_TOP_LEVEL_CATEGORY },
]

/**
 * The one top-level category from `GET /categories` that isn't a cabinet — matching the string
 * `isCountertop` tests furniture against (FurnitureModelLabel/furnitureModel.helpers).
 *
 * The "add cabinet" flow (REQ-293) hides it, and the synthetic "Other" above, from its top-level
 * dropdown: each of the three gets its own + Add entry and its own creation panel.
 */
export const COUNTERTOPS_TOP_LEVEL_CATEGORY = "Countertops"
